export default __webpack_public_path__ + "locales/sr-Cyrl-RS/PreparationPortal.json?hash=b3fbdb66692c62dc5fa8cf54f3896e71";